import React from 'react';
import styled from 'styled-components';

/**
 * ! 삭제 예정 (22. 09. 30. SJY)
 * @returns {컬럼이 가로형}
 */

interface IProps {
  children: JSX.Element[] | JSX.Element;
  style?: React.CSSProperties;
}
const HorizontalTable: React.FC<IProps> = ({ children, style }) => {
  return <StyledTable style={style}>{children}</StyledTable>;
};

export default HorizontalTable;

const StyledTable = styled.table`
  width: 100%;

  thead {
    width: 100%;
    /* background-color: blue; */
    tr > th {
      color: ${(props) => props.theme.colors.blueText};
      font-weight: 600;
      text-align: left;
      padding-bottom: 0.5rem;
    }
  }
  tbody {
    tr > th {
      color: ${(props) => props.theme.colors.black};
      font-weight: 600;
      text-align: left;
      padding-bottom: 0.5rem;
    }
    tr > th:nth-child(2),
    tr > td:nth-child(2) {
      width: 45%;
    }
    .tr_content {
      height: 3rem;
    }
    .tr_content > td:nth-child(2) {
      padding-right: 1rem;
    }
    td:nth-child(3) {
      width: 40%;
    }
    td:nth-child(4) {
      text-align: left;
      padding-left: 0.5rem;
    }
    .toggle_tr {
      width: 100%;
      /* background-color: khaki; */
      display: flex;
      align-items: center;

      td {
        width: 11rem;
        display: flex;
        justify-content: flex-start;
        p {
          margin-top: 0.25rem;
          margin-right: 0.5rem;
        }
      }
      td:nth-child(2) {
        width: 12rem;
      }
      td:nth-child(3) {
        width: 15rem;
      }
    }
  }
  .code_name_th,
  .code_name_td {
    vertical-align: baseline;
    width: 5%;
    text-align: right;
    padding-right: 2rem;
  }
  .code_name_td {
    height: 9rem;
    font-weight: 700;
  }
  .image_td {
    width: 50%;
    vertical-align: top;
  }
`;
